import React from 'react';
import NotificationAtom from '../Notifications/NotificationAtom';

const Notification = (props) => {



  return (
    <>
      <div className="modal fade" id="notificationModal" tabIndex="-1" role="dialog" aria-labelledby="notificationsLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="addNewAddress commonModal">
              <span className="close" data-dismiss="modal">
                <img src={`https://cdn.regopayments.com/tenants/${props.state.theme.shortName}/web/public/assets/images/modal-close.svg`} alt="close" className="img-fluid" />
              </span>
              <h1 className="modal-heading">Notifications</h1>

              <NotificationAtom {...props} />
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Notification;
